import { useParams } from "react-router";
import { useSelector } from "react-redux";

import { BAND_PATHS } from "Bands/router";
import { useEventRoute } from "Bands/utils";
import { dataMetaSelector, eventBlockSelectorCreator } from "Bands/state";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { Button, Card, Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, ITheme } from "shared/types";

import { AddPeopleForm, PeopleBlockTable } from "./containers";
import {
  BAND_ACTIONS,
  EventUniqueBlocks,
  IEventPeopleBlock,
} from "Bands/types";
import { FourOhFour, FourOhThree } from "shared/pages";
import { mapUserPermissions } from "shared/utils";
import CopyBlockModal from "../copy-block/CopyBlockModal";

const peopleBlockCopy = copy.peopleBlock.edit;

export const EditPeopleBlockPage = () => {
  const { pushRoute } = useEventRoute();
  let { blockId } = useParams<{ blockId: string }>();

  const peopleBlockSelector = eventBlockSelectorCreator(
    blockId,
    EventUniqueBlocks.people
  );

  const peopleBlock = useSelector(peopleBlockSelector) as IEventPeopleBlock;

  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.getEventPeopleBlocks)
  );

  const renderContent = () => {
    if (!peopleBlock) return <Loader />; // fetching

    return (
      <Spacer size="m">
        {peopleBlock.users?.length === 0 && (
          <CopyBlockModal
            blockType={EventUniqueBlocks.people}
            deleteBlockId={blockId}
          />
        )}
        <AddPeopleForm blockId={blockId} users={peopleBlock.users} />
        <PeopleBlockTable blockId={blockId} users={peopleBlock.users} />
        <Button
          onClick={() => pushRoute(BAND_PATHS.BAND_EVENT)}
          theme={ITheme.secondary}
        >
          {copy.form.finish}
        </Button>
      </Spacer>
    );
  };

  if (apiMeta?.status !== IAPIState.pending && !peopleBlock)
    return <FourOhFour />;

  if (peopleBlock && !mapUserPermissions(peopleBlock.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  return (
    <Card
      title={peopleBlockCopy.title.replace(
        "%title",
        peopleBlock?.title || "..."
      )}
      icon={User}
    >
      {renderContent()}
    </Card>
  );
};
